module.exports = __webpack_public_path__ + "static/media/uhn-image.85e2960f.png";